import React from "react";
import LoginPage from "../pages/LoginPage";
import Pricing from "../pages/Pricing";
import Info from "../components/pricing/info/Info";
import RedirectToOnboarding from "../../components/redirect_to_login/RedirectToOnboarding";
import ForgotPage from "../pages/ForgotPage";
import { Navigate } from "react-router-dom";
import TermsOfUse from "../pages/TermsOfUse";

const OnboardingRoutes = [
  {
    path: "/",
    element: <RedirectToOnboarding />,
    errorElement: <Navigate to="/" replace />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/signup",
    element: <LoginPage />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPage />,
  },
  {
    path: "/pricing",
    element: <Pricing />,
  },
  {
    path: "/terms-of-use",
    element: <TermsOfUse />,
  },
  {
    path: "/pricing/info",
    element: <Info />,
  },
];
export default OnboardingRoutes;
